import React from 'react'
import PleaseLoginImage from '../../../../assets/images/please-login.jpg'

export function NonLogin() {
  return (
    <div className='notification-non-login'>
      <img className="notification-non-login__image" src={PleaseLoginImage} />
      <h3 className="notification-non-login__title title-2">Masuk ke Akun Kamu</h3>
      <p className="notification-non-login__desc small-title-1">Dapatkan notifikasi terbaru di sini</p>
      <a href="/users/login" className='notification-non-login__button button-primary button-l title-3'>
        Masuk / Daftar
      </a>
    </div>
  )
}
